import { ReactNode } from "react";
import { Alert, Box, Button, AlertProps } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import InfoIcon from "@mui/icons-material/Info";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { IModalProps, Modal } from "../Modal";

export interface ConfirmModalProps extends Omit<IModalProps, "actions"> {
  isLoading: boolean;
  error: string;
  onConfirm?: () => void;
  confirmButtonMessage?: string;
  disableConfirmButton?: boolean;
  disableBackdropClick?: boolean;
  secondaryAction?: ReactNode;
  hideConfirmButton?: boolean;
  formId?: string;
  severityMessage?: AlertProps["severity"];
}

export const ConfirmModal = ({
  title,
  children,
  open,
  onClose,
  isLoading,
  onConfirm,
  error,
  confirmButtonMessage = "Ok",
  disableBackdropClick = false,
  disableConfirmButton = false,
  secondaryAction,
  hideConfirmButton = false,
  formId,
  severityMessage = "error",
}: ConfirmModalProps) => (
  <Modal
    title={<Box sx={{ display: "flex", alignItems: "center" }}>{title}</Box>}
    open={open}
    {...(disableBackdropClick ? {} : { onClose })}
    actions={
      <Box sx={{ display: "flex", mr: "8px" }}>
        <Button
          variant="outlined"
          color="secondary"
          sx={{ mr: "10px" }}
          disabled={isLoading}
          startIcon={<ArrowBackOutlinedIcon />}
          onClick={onClose as any}
        >
          Back
        </Button>
        {!error && !hideConfirmButton && (
          <>
            <LoadingButton
              autoFocus
              onClick={onConfirm}
              variant="contained"
              loading={isLoading}
              disabled={disableConfirmButton}
              {...(formId ? { type: "submit", form: formId } : {})}
            >
              {confirmButtonMessage}
            </LoadingButton>
            {secondaryAction}
          </>
        )}
      </Box>
    }
  >
    {error ? (
      <Alert severity={severityMessage}>{error}</Alert>
    ) : (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {!secondaryAction && (
          <InfoIcon color="primary" sx={{ mr: "5px" }} fontSize="large" />
        )}
        {children}
      </Box>
    )}
  </Modal>
);
